export default __webpack_public_path__ + "static/media/img_shouye_hexinjishu.42dfc383.jpg";